import {
  Account,
  AccountServiceName,
  AccountServiceNameLabel,
} from '@rci/self-serve-fido/state/user-information/account';
import { UserInformation } from '@rci/self-serve-fido/state/user-information/user-information';
import { UserAccount } from '@rogers/self-serve-common/account';
import { get } from 'lodash';
import { throwError } from 'rxjs';
import { AccountName } from './account-detail.model';

export class AccountHelper {
  static throwError = (error: any) => {
    throw throwError(error);
  };

  /* Used for transform response before saving into the store */
  static transformAccountList(accounts: UserAccount[]): UserAccount[] {
    return accounts
      .map(account => {
        // Temp fix for Internet accounts
        if (account.accountNumber.startsWith('2')) {
          account.isCableOrInternetAccount = true;
          account.isWirelessOrConsolidatedAccount = false;
        }

        let accountOrder;
        switch (true) {
          case account.isActiveAccount:
            accountOrder = 0;
            break;
          case account.isSuspendedAccount:
            accountOrder = 1000;
            break;
          case account.isCancelledAccount:
            accountOrder = 2000;
            break;
          default:
            accountOrder = 9000;
        }

        if (account.isCableOrInternetAccount) {
          accountOrder += 100;
        } else if (account.isPrepaidAccount) {
          accountOrder += 200;
        }

        account.accountOrder = accountOrder;

        return account;
      })
      .sort(AccountHelper.accountListCompareFn);
  }

  static accountListCompareFn(a: UserAccount, b: UserAccount): number {
    if (a.accountOrder !== b.accountOrder) {
      return a.accountOrder > b.accountOrder ? 1 : -1;
    }
    return a.accountNumber > b.accountNumber ? 1 : -1;
  }

  static transformUserAccountsToAccounts(accounts: UserAccount[]): Account[] {
    return accounts.map(account => {
      const { accountNumber, accountOrder, contactId, fraud, accountStatus, isOwner, isSubscriber, isGroupId } =
        account;
      // Values are not exist on the new API
      const delinquentStatus = null;
      const fidoGuid = null;
      const reasonCode = null;
      const serviceNameLabelValue = '';
      const { serviceName, serviceNameLabel } = AccountHelper.getServiceNameAndLabel(account);
      const status = accountStatus;

      return {
        accountNumber,
        accountOrder: accountOrder || 0,
        contactId,
        delinquentStatus,
        fidoGuid,
        reasonCode,
        serviceName,
        serviceNameLabel,
        serviceNameLabelValue,
        status,
        fraud,
        isOwner,
        isSubscriber,
        isGroupId,
      };
    });
  }

  static getUpdatedUserInformation(
    userInformation: UserInformation,
    accounts: Account[],
    accountName: AccountName,
  ): UserInformation {
    const firstName = get(userInformation, 'firstName') || get(accountName, 'firstName', '');
    const lastName = get(userInformation, 'lastName') || get(accountName, 'lastName', '');
    const lowerFirstName = firstName.toLowerCase();
    const isAccountLinked = accounts.length > 0;

    return {
      ...userInformation,
      accounts,
      firstName,
      lastName,
      lowerFirstName,
      isAccountLinked,
      selectedAccountNumber: isAccountLinked ? accounts[0].accountNumber : '',
      accessToken: userInformation.accessToken,
    };
  }

  static getServiceNameAndLabel(account: UserAccount): {
    serviceName: AccountServiceName;
    serviceNameLabel: AccountServiceNameLabel;
  } {
    let serviceName;
    if (account.isCableOrInternetAccount) {
      serviceName = 'Internet/TV';
    } else if (account.isWirelessOrConsolidatedAccount) {
      serviceName = 'Wireless';
    } else {
      serviceName = 'Prepaid';
    }
    const serviceNameLabel = AccountHelper.getServiceNameLabel(serviceName);
    return { serviceName, serviceNameLabel };
  }

  static getServiceNameLabel(serviceName: AccountServiceName): AccountServiceNameLabel {
    return serviceName === 'Internet/TV' ? 'Internet' : 'Mobile';
  }
}
